import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'
import { Meeting } from 'src/app/interfaces/meeting.interface';

/*
  Generated class for the CultpProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({providedIn: 'root'})
export class CultoProvider {
  baseUrl = environment.API_URL;
  instituicaoFiltragem: any;
  constructor(public http: HttpClient) {}

  getCultos() {
    return this.http.get<any>(this.baseUrl + '/culto/buscar')
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  removerPessoa(pessoa: any) {
    return this.http.post<any>(this.baseUrl + '/culto/remover-pessoa',
    { 'pessoa': pessoa })
    .pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }
  
  getCultosFiltro(filtro: any) {
    return this.http.post<any>(this.baseUrl + '/culto/buscar-filtro', filtro)
      .pipe(map(data => {
        return !data.error ? data : false;
      }));
  }

  getNotificacoes() {
    return this.http.get<any>(this.baseUrl + '/culto/notificacoes')
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  confirmarPresenca(culto: { id: any; presenca: any; }) {
    return this.http.post<any>(this.baseUrl + '/culto/confirmar-presenca',
      culto
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getCultoAgenda(idCulto: any, dataInicio: any, idCultoAgenda: any) {
    return this.http.get<any>(this.baseUrl + '/culto/get-culto-agenda', {
      params: {
        idCulto: idCulto,
        dataInicio: dataInicio,
        idCultoAgenda: idCultoAgenda,
        esconderEncarregados: 'true'
      }
    }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getPresencaLiderados(idCulto: any) {
    return this.http.post<any>(this.baseUrl + '/culto/presenca-liderados',
      { 'idCulto': idCulto }
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }


  getTipos(idInstituicao: any) {
    return this.http.get<any>(this.baseUrl + '/culto/culto-tipos', {
      params: {
        idInstituicao: idInstituicao,
      }
    }).pipe(map(data => {
      return data;
    }));
  }

  getPresencaEncarregados(idCulto: any) {
    return this.http.post<any>(this.baseUrl + '/culto/presenca-encarregados',
      { 'idCulto': idCulto }
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  salvarPresencas(idCulto: any, dataInicio: any, id: any, liderados: any) {
    var vinculados = new Array();

    liderados.forEach((element: any) => {
      if (element.presenca == true) {
        vinculados.push({ idPessoa: element.idPessoa });
      }
    });

    return this.http.post<any>(this.baseUrl + '/culto/save-presencas', {
      idCulto: idCulto,
      dataInicio: dataInicio,
      id: id,
      vinculados: vinculados
    }).pipe(map(data => {
      return !data.error ? data : false;
    }));
  }

  salvarPresenca(idCulto: any, dataInicio: any, id: any, pessoa = null, canUpdate = true) {

    return this.http.post<any>(this.baseUrl + '/culto/save-presenca', {
      idCulto: idCulto,
      dataInicio: dataInicio,
      id: id,
      pessoa: pessoa,
      canUpdate: canUpdate
    }).pipe(map(data => {
      return data;
    }));
  }

  salvarPresencaEncarregado(idCulto: any, dataInicio: any, id: any, pessoa: any) {

    return this.http.post<any>(this.baseUrl + '/culto/save-encarregado', {
      idCulto: idCulto,
      dataInicio: dataInicio,
      id: id,
      encarregado: pessoa
    }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  setPresencaBarcode(idPessoa: any, idCultoAgenda: any) {

    return this.http.post<any>(this.baseUrl + '/culto/presenca-encarregado-barcode', {
      idPessoa: idPessoa,
      idCultoAgenda: idCultoAgenda,
    }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));

  }

  getEncarregados(filtro: { q: any; }, pag: { currentPage: any; }, idCultoAgenda: any) {
    return this.http.get<any>(this.baseUrl + '/culto/buscar-encarregados',
      {
        observe: 'response', params:
        {
          "expand": "pessoa,pessoaFuncoesEspec",
          "page": pag.currentPage,
          "per-page": "10",
          "q": filtro.q,
          "idCultoAgenda": idCultoAgenda
        }
      })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          encarregados: data.body,
          pagination: pag
        };
      }));
  }

  salvarPermissaoLeituraQrCode(idEscalaFuncaoPessoa: any, permissaoLeituraQrcode = false) {
    return this.http
      .post<any>(this.baseUrl + '/culto/salvar-permissao-leitura-qr-code', {
        idEscalaFuncaoPessoa: idEscalaFuncaoPessoa,
        permissaoLeituraQrcode: permissaoLeituraQrcode,
      })
      .pipe(map(data => {
        return data;
      }));
  }

  setInstituicaoFiltragem(instituicao: null) {
    this.instituicaoFiltragem = instituicao;
  }

  getInstituicaoFiltragem() {
    return this.instituicaoFiltragem;
  }

  postCalendar(dataInicio: any, dataFim: any, canUpdate = true) {
    return this.http.post<any>(this.baseUrl + '/culto/post-calendar', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      canUpdate: canUpdate
    }).pipe(map(data => {
      return data;
    }));
  }

  postListarCultosCheckin(idInstituicao: any, idCulto: any) {
    return this.http
      .post<Meeting[]>(this.baseUrl + '/culto/post-listar-cultos-checkin', {
        idInstituicao: idInstituicao,
        idCulto: idCulto,
      })
      .pipe(map(data => {
        return data;
      }));
  }
}
